import {
    CHARTS_WHICH_NEED_ADJUSTMENT_FOR_SARCASM, EMOTION_OR_SENTIMENT_PERCENTAGE_TREND_CHART_IDS,
    EMOTION_OR_SENTIMENT_MENTIONS_CHARTS_IDS, EMOTION_OR_THREE_CLASS_SENTIMENT_PIE_CHARTS_IDS,
    EMOTION_OR_SENTIMENT_TREND_CHART_IDS, FIVE_CLASS_SENTIMENT_PIE_CHARTS_IDS, MENTIONS_LABEL, PARSE_INT_RADIX,
    UPDATE_SELECTED_CHART_DETAILS_AFTER_SARCASM_TOGGLED, EMOTION_PIE_CHART_ID
} from './constants';
import { NO_SPECIFIC_EMOTION } from '../../../home/redux/constants';
import {
    getThreeClassSentimentCategory,
    doesTrendChartElementMatchCommentDate,
    isEmotionOrSentimentBarChartWithData
} from './updateChartForRelevanceUpdatesOfCommentOrTweetService';
import { isSubTopicClustersChartWithData } from './updateChartForRelevanceUpdatesOfPostService';
  
export function updateChartForToggledSarcasticCommentOrTweet(chartId,commentOrTweetAfterToggling,emotionCategoryBeforeTogglingTweetOrComment,sentimentCategoryBeforeTogglingTweetOrComment,trendChartTimeUnit) {
    return dispatch => {
        dispatch({
            type: UPDATE_SELECTED_CHART_DETAILS_AFTER_SARCASM_TOGGLED,
            data: {
                chartId: chartId,
                commentOrTweetAfterToggling: commentOrTweetAfterToggling,
                emotionCategoryBeforeTogglingTweetOrComment: emotionCategoryBeforeTogglingTweetOrComment,
                sentimentCategoryBeforeTogglingTweetOrComment: sentimentCategoryBeforeTogglingTweetOrComment,
                trendChartTimeUnit: trendChartTimeUnit
            }
        });
    };
  }

export function reducer(state, action) {
    if (action.type !== UPDATE_SELECTED_CHART_DETAILS_AFTER_SARCASM_TOGGLED) {
        return state;
    }
    if (!state) {
        return state;
    }
    const { 
        chartId, 
        commentOrTweetAfterToggling, 
        emotionCategoryBeforeTogglingTweetOrComment, 
        sentimentCategoryBeforeTogglingTweetOrComment,
        trendChartTimeUnit
    } = action.data;
    if ((!state.hasOwnProperty(chartId)) || (!CHARTS_WHICH_NEED_ADJUSTMENT_FOR_SARCASM.includes(chartId))) {
        return state;
    }
    const emotionCategoryAfterTogglingTweetOrComment   = commentOrTweetAfterToggling.emotion.category;
    const sentimentCategoryAfterTogglingTweetOrComment = commentOrTweetAfterToggling.sentiment.category;
    
    const threeClassSentimentCategoryBeforeToggling = getThreeClassSentimentCategory(sentimentCategoryBeforeTogglingTweetOrComment);
    const threeClassSentimentCategoryAfterToggling  = getThreeClassSentimentCategory(sentimentCategoryAfterTogglingTweetOrComment);
  
    if (EMOTION_OR_SENTIMENT_MENTIONS_CHARTS_IDS.includes(chartId) && state[chartId].length > 0) {
        let newState = updateEmotionOrSentimentMentionsCharts(
            state, 
            chartId, 
            emotionCategoryBeforeTogglingTweetOrComment, 
            threeClassSentimentCategoryBeforeToggling, 
            emotionCategoryAfterTogglingTweetOrComment, 
            threeClassSentimentCategoryAfterToggling
        );
        return newState;
    }

    else if (isTrendOrPercentageTrendChart(chartId) && state[chartId].length > 0) {
        let newState = updateEmotionOrSentimentTrendCharts(
            state,
            commentOrTweetAfterToggling,
            chartId,
            emotionCategoryBeforeTogglingTweetOrComment,
            threeClassSentimentCategoryBeforeToggling,
            threeClassSentimentCategoryAfterToggling,
            trendChartTimeUnit
        );
        return newState;
    }
    
    else if (EMOTION_OR_THREE_CLASS_SENTIMENT_PIE_CHARTS_IDS.includes(chartId) && state[chartId].data.length > 0) {
        const pieChartMentionsToDeductFrom = [
            threeClassSentimentCategoryBeforeToggling + MENTIONS_LABEL, 
            emotionCategoryBeforeTogglingTweetOrComment
        ];
        const pieChartMentionsToAddTo = [
            threeClassSentimentCategoryAfterToggling + MENTIONS_LABEL,
            emotionCategoryAfterTogglingTweetOrComment
        ];
        let newState = updateEmotionOrSentimentPieCharts (
            state,
            chartId,
            pieChartMentionsToDeductFrom,
            pieChartMentionsToAddTo
        );
        return newState;
    }

    else if (FIVE_CLASS_SENTIMENT_PIE_CHARTS_IDS.includes(chartId) && state[chartId].data.length > 0) {
        const pieChartMentionsToDeductFrom = [
            sentimentCategoryBeforeTogglingTweetOrComment + MENTIONS_LABEL
        ];
        const pieChartMentionsToAddTo = [
            sentimentCategoryAfterTogglingTweetOrComment + MENTIONS_LABEL
        ];
        let newState = updateEmotionOrSentimentPieCharts (
            state,
            chartId,
            pieChartMentionsToDeductFrom,
            pieChartMentionsToAddTo
        );
        return newState;
    }
    
    else if (isEmotionOrSentimentBarChartWithData(chartId, state)){
        let newState = updateEmotionOrSentimentBarCharts (
            state,
            chartId,
            emotionCategoryBeforeTogglingTweetOrComment,
            emotionCategoryAfterTogglingTweetOrComment
        );
        return newState;
    }

    else if (isSubTopicClustersChartWithData(chartId, state)) {
        let newState = updateSubTopicClustersChart(
            state,
            chartId,
            commentOrTweetAfterToggling,
            emotionCategoryBeforeTogglingTweetOrComment,
            emotionCategoryAfterTogglingTweetOrComment
        );
        return newState;
    }
    return state;
}

export function updateEmotionOrSentimentMentionsCharts(
    state,
    chartId,
    emotionCategoryBeforeTogglingTweetOrComment,
    threeClassSentimentCategoryBeforeToggling,
    emotionCategoryAfterTogglingTweetOrComment,
    threeClassSentimentCategoryAfterToggling) {
    let newState = JSON.parse(JSON.stringify(state));
        for (const element of newState[chartId]) {
            if ([emotionCategoryBeforeTogglingTweetOrComment, threeClassSentimentCategoryBeforeToggling].includes(element.category)) {
                element.count = parseInt(element.count, PARSE_INT_RADIX) - 1;
            } else if ([emotionCategoryAfterTogglingTweetOrComment, threeClassSentimentCategoryAfterToggling].includes(element.category)) {
                element.count = parseInt(element.count, PARSE_INT_RADIX) + 1;
            }
        }
    return newState;
}

export function isTrendOrPercentageTrendChart(chartId) {
    return (EMOTION_OR_SENTIMENT_TREND_CHART_IDS.includes(chartId) || EMOTION_OR_SENTIMENT_PERCENTAGE_TREND_CHART_IDS.includes(chartId));
}

export function updateEmotionOrSentimentTrendCharts(
    state,
    commentOrTweetAfterToggling,
    chartId,
    emotionCategoryBeforeTogglingTweetOrComment,
    threeClassSentimentCategoryBeforeToggling,
    threeClassSentimentCategoryAfterToggling,
    trendChartTimeUnit
    ) {
    const emotionCategoryAfterTogglingTweetOrComment = commentOrTweetAfterToggling.emotion.category;
    let newState = JSON.parse(JSON.stringify(state));

    for (const categoryElement of newState[chartId]) {
        if ([emotionCategoryBeforeTogglingTweetOrComment, threeClassSentimentCategoryBeforeToggling].includes(categoryElement.category.toLowerCase())) {
            categoryElement.data = deductCountFromCorrectDateInEmotionSentimentTrendChart(
                categoryElement.data, 
                commentOrTweetAfterToggling,
                trendChartTimeUnit
            );
        } else if ([emotionCategoryAfterTogglingTweetOrComment, threeClassSentimentCategoryAfterToggling].includes(categoryElement.category.toLowerCase())) {
            categoryElement.data = addCountToCorrectDateInEmotionSentimentTrendChart(
                categoryElement.data, 
                commentOrTweetAfterToggling,
                trendChartTimeUnit
            );
        }
    }
    return newState;
}

export function deductCountFromCorrectDateInEmotionSentimentTrendChart(
    categoryElementData, 
    commentOrTweetAfterToggling,
    trendChartTimeUnit
    ) {
    for (const dataElement of categoryElementData) {
        if (doesTrendChartElementMatchCommentDate(dataElement, commentOrTweetAfterToggling, trendChartTimeUnit)) {
            dataElement[1] = parseInt(dataElement[1], PARSE_INT_RADIX) - 1;
        }
    }
    return categoryElementData;
}

export function addCountToCorrectDateInEmotionSentimentTrendChart(
    categoryElementData, 
    commentOrTweetAfterToggling,
    trendChartTimeUnit
    ) {
    for (const dataElement of categoryElementData) {
        if (doesTrendChartElementMatchCommentDate(dataElement, commentOrTweetAfterToggling, trendChartTimeUnit)) {
            dataElement[1] = parseInt(dataElement[1], PARSE_INT_RADIX) + 1;
        }
    }
    return categoryElementData;
}

export function updateEmotionOrSentimentPieCharts(
    state,
    chartId,
    pieChartMentionsToDeductFrom,
    pieChartMentionsToAddTo,
    ) {
    let newState = JSON.parse(JSON.stringify(state));
    for (const categoryElement of newState[chartId].data) {
        if (pieChartMentionsToDeductFrom.includes(categoryElement[0].toLowerCase())) {
            categoryElement[1] = parseInt(categoryElement[1], PARSE_INT_RADIX) - 1;
            break;
        }
    }
    for (const categoryElement of newState[chartId].data) {
        if (pieChartMentionsToAddTo.includes(categoryElement[0].toLowerCase())) {
            categoryElement[1] = parseInt(categoryElement[1], PARSE_INT_RADIX) + 1;
            break;
        }
    }
    if (chartId === EMOTION_PIE_CHART_ID) {
        newState = updateEmotionPieChartCount(
            newState,
            chartId,
            pieChartMentionsToDeductFrom,
            pieChartMentionsToAddTo,
        );
    }
    return newState;
}

export function updateEmotionPieChartCount(
    newState,
    chartId,
    pieChartMentionsToDeductFrom,
    pieChartMentionsToAddTo,
) {
    if (pieChartMentionsToDeductFrom.includes(NO_SPECIFIC_EMOTION)) {
        newState[chartId].count += 1;
    }
    else if (pieChartMentionsToAddTo.includes(NO_SPECIFIC_EMOTION)) {
        newState[chartId].count -= 1;
    }
    return newState;
}

export function updateEmotionOrSentimentBarCharts (
    state,
    chartId,
    emotionCategoryBeforeTogglingTweetOrComment,
    emotionCategoryAfterTogglingTweetOrComment
    ) {
    let newState = JSON.parse(JSON.stringify(state));
    let i = 0;
    for (const categoryElement of newState[chartId].categories) {
        if (categoryElement.toLowerCase() === emotionCategoryBeforeTogglingTweetOrComment) {
            newState[chartId].values[i] = parseInt(newState[chartId].values[i], PARSE_INT_RADIX) - 1;
        }
        else if (categoryElement.toLowerCase() === emotionCategoryAfterTogglingTweetOrComment) {
            newState[chartId].values[i] = parseInt(newState[chartId].values[i], PARSE_INT_RADIX) + 1;
        }
        i += 1;
    }
    return newState;
}

export function updateSubTopicClustersChart(
    state,
    chartId,
    commentOrTweetAfterToggling,
    emotionCategoryBeforeTogglingTweetOrComment,
    emotionCategoryAfterTogglingTweetOrComment
) {
    let commentOrTweetSubTopicId = commentOrTweetAfterToggling.subTopicId;
    if (commentOrTweetSubTopicId === null || commentOrTweetSubTopicId < 0) {
        return state;
    }
    let newState = JSON.parse(JSON.stringify(state));
    for (let subTopic of newState[chartId].subTopics) {
        if (subTopic.id !== commentOrTweetSubTopicId) {
            continue;
        }
        subTopic.emotionCommentCounts[emotionCategoryBeforeTogglingTweetOrComment] -= 1;
        subTopic.emotionCommentCounts[emotionCategoryAfterTogglingTweetOrComment]  += 1;
        break;
    }
    return newState;
}



// WEBPACK FOOTER //
// ./src/features/shared-components/chart/redux/updateChartForToggledSarcasticCommentOrTweetService.js